export default __webpack_public_path__ + "static/media/click.ce2660ff.mp3";